import SupermarketDeport from './supermarket_deport.vue';

export default SupermarketDeport;
